<app-head></app-head>

<div class="main-container">

  <div class="top-container">
    <h2 style="font-family: 'Lato', sans-serif; font-weight: 900"> Dashboard admin </h2>
    <button mat-raised-button style="color: #16191e" (click)="isPopinOpen=true">Ajouter un utilisateur</button>
  </div>

  <div class="user-dashboard">
    <table mat-table [dataSource]="userData" class="table-container">
      <ng-container matColumnDef="username">
        <th mat-header-cell *matHeaderCellDef> Username</th>
        <td mat-cell *matCellDef="let element">
          <ng-container>
            {{ element.username }}
          </ng-container>

        </td>
      </ng-container>

      <ng-container matColumnDef="email">
        <th mat-header-cell *matHeaderCellDef> E-mail</th>
        <td mat-cell *matCellDef="let element">
          <ng-container>
            {{ element.email }}
          </ng-container>
        </td>
      </ng-container>

      <ng-container matColumnDef="is_active">
        <th mat-header-cell *matHeaderCellDef> Active</th>
        <td mat-cell *matCellDef="let element">
          <ng-container>
            {{ element.is_active }}
          </ng-container>
        </td>
      </ng-container>

      <ng-container matColumnDef="is_admin">
        <th mat-header-cell *matHeaderCellDef> Admin</th>
        <td mat-cell *matCellDef="let element">
          <ng-container>
            {{ element.is_admin }}
          </ng-container>
        </td>
      </ng-container>


      <ng-container matColumnDef="id_update">
        <th mat-header-cell *matHeaderCellDef></th>
        <td mat-cell *matCellDef="let element">
          <mat-icon (click)="updateUser(element)">account_box</mat-icon>
        </td>
      </ng-container>

      <!-- Delete button Column -->
      <ng-container matColumnDef="id_delete">
        <th mat-header-cell *matHeaderCellDef></th>
        <td mat-cell *matCellDef="let element">
          <mat-icon (click)="deleteUser(element.id)">delete</mat-icon>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="userColumns" class="mat-header-row"></tr>
      <tr mat-row *matRowDef="let row; columns: userColumns;"></tr>
    </table>
  </div>

  <div>
    <h2 style="font-family: 'Lato', sans-serif; font-weight: 900; margin-top: 50px"> Historique transaction </h2>
  </div>

  <div class="transaction-dashboard">
    <table mat-table [dataSource]="transactionData" class="table-container">
      <ng-container matColumnDef="item_name">
        <th mat-header-cell *matHeaderCellDef> Produits</th>
        <td mat-cell *matCellDef="let element">
          <ng-container>
            {{ element.item_name }}
          </ng-container>

        </td>
      </ng-container>

      <ng-container matColumnDef="type">
        <th mat-header-cell *matHeaderCellDef>Type</th>
        <td mat-cell *matCellDef="let element">
          <ng-container>
            {{ element.type }}
          </ng-container>
        </td>
      </ng-container>

      <ng-container matColumnDef="actual_quantity">
        <th mat-header-cell *matHeaderCellDef> Quantité</th>
        <td mat-cell *matCellDef="let element">
          <ng-container>
            {{ element.actual_quantity }}
          </ng-container>
        </td>
      </ng-container>

      <ng-container matColumnDef="added_by">
        <th mat-header-cell *matHeaderCellDef> Ajouté Par</th>
        <td mat-cell *matCellDef="let element">
          <ng-container>
            {{ element.added_by }}
          </ng-container>
        </td>
      </ng-container>


      <ng-container matColumnDef="updated_date">
        <th mat-header-cell *matHeaderCellDef> Date</th>
        <td mat-cell *matCellDef="let element">
          <ng-container>
            {{ element.updated_date }}
          </ng-container>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="transactionColumns; sticky: true" class="mat-header-row"></tr>
      <tr mat-row *matRowDef="let row; columns: transactionColumns;"></tr>
    </table>
  </div>

</div>


<app-popin *ngIf="isPopinOpen" (close)="closePopin()">
  <div class="create-container">
    <h2 style="font-weight: 600; text-align: center">Ajouter un utilisateur</h2>

    <div class="line-container">
      <input type="text" class="text-input" style="flex: 1" id="username" [(ngModel)]="userForm.username"
             placeholder="Username" required>
      <input type="text" class="text-input" style="flex: 1" id="email" [(ngModel)]="userForm.email"
             placeholder="email">
    </div>

    <div class="line-container">
      <input type="password" class="text-input" id="password" [(ngModel)]="userForm.password"
             placeholder="Mot de passe" required>
    </div>
    <div class="line-container">
      <input type="password" class="text-input" id="confirmPassword" [(ngModel)]="userForm.confirm_password"
             placeholder="Confirmer mot de passe" required>
    </div>

    <button mat-raised-button (click)="createUser()">Ajouter</button>
  </div>
  <div *ngIf="errorMessage">
    <p style="color: red; font-size: 14px">{{ errorMessage }}</p>
  </div>
</app-popin>

<app-popin *ngIf="isdeletePopin" (close)="isdeletePopin=false">
  <div class="create-container">
    <h3 style="font-weight: 600; text-align: center">Confirmer la suppression</h3>
    <button mat-raised-button (click)="confirmDelete()">Confirmer</button>
    <button mat-raised-button (click)="isdeletePopin=false">Annuler</button>
  </div>
</app-popin>


